import { browserOrDesktop } from '../utils/browserOrDesktop';
import * as browser from './file.web.browser';
import * as desktop from './file.web.desktop';

export const loadDocument = browserOrDesktop(browser.loadDocument, desktop.loadDocument);
export const getFilePath = browserOrDesktop(browser.getFilePath, desktop.getFilePath);
export const downloadFile = browserOrDesktop(browser.downloadFile, desktop.downloadFile);
